.trigger {
	display: inline-block;
	cursor: default;
}

.tooltip {
	position: fixed;
	z-index: 9999;
	background-color: #333;
	color: #fff;
	padding: 0.5rem 0.75rem;
	border-radius: 4px;
	font-size: 0.875rem;
	max-width: 300px;
	word-wrap: break-word;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	pointer-events: none;
	animation: fadeIn 0.2s ease-in-out;
	white-space: normal;

	&.top {
		.arrow {
			bottom: -4px;
			left: 50%;
			transform: translateX(-50%) rotate(45deg);
		}
	}

	&.bottom {
		.arrow {
			top: -4px;
			left: 50%;
			transform: translateX(-50%) rotate(45deg);
		}
	}

	&.left {
		.arrow {
			right: -4px;
			top: 50%;
			transform: translateY(-50%) rotate(45deg);
		}
	}

	&.right {
		.arrow {
			left: -4px;
			top: 50%;
			transform: translateY(-50%) rotate(45deg);
		}
	}
}

.arrow {
	position: absolute;
	width: 8px;
	height: 8px;
	background-color: #333;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
